import { Injectable } from '@angular/core';
import { Command, CommandService, UserIdService } from '@spartacus/core';
import { UserPasswordService } from '@spartacus/user/profile/core';
import { CustomUserProfileConnector } from '../../profile/custom-register/store/conectors/custom-user-profile.connector';

@Injectable({
  providedIn: 'root'
})
export class CustomUserPasswordService extends UserPasswordService {
  constructor(
    protected customUserProfileConnector: CustomUserProfileConnector,
    protected userIdService: UserIdService,
    protected command: CommandService
  ) {
    super(customUserProfileConnector, userIdService, command);
  }

  protected override requestForgotPasswordEmailCommand: Command<{
    email: string;
  }> = this.command.create((payload) => this.customUserProfileConnector.requestForgotPasswordEmail(payload.email));
}
